<template>
  <!-- <el-select
      v-model="groupId"
      placeholder="请选择行业管理"
      clearable
      @change="handleChange"
    >
      <el-option
        v-for="item in list"
        :key="item.groupId"
        :label="item.groupName"
        :value="item.groupId"
      >
      </el-option>
    </el-select> -->
  <div>
    <!-- <el-cascader
      v-if="flag === 0"
      v-model="selectedOptions"
      style="width:100%"
      :options="list"
      :props="props"
    ></el-cascader> -->
    <el-select
      v-model="selectedOptions"
      style="width:100%"
      placeholder="请选择二级类目"
      @change="handleChange">
      <el-option
        v-for="item in list"
        :key="item.serviceCategoryId"
        :label="item.serviceCategoryName"
        :value="item.serviceCategoryId"
      >
      </el-option>
    </el-select>
  </div>
</template>

<script>
export default {
  name: 'CategoryServiceSelectNew2',
  components: {},
  props: {
    value: {
      required: true
    },
    callback: {
      type: Function
    },
    option: {
      type: Object,
      default() {
        return {
          serviceId: null,
          classId: []
        }
      }
    }
  },
  data() {
    return {
      props: {
        label: 'serviceCategoryName',
        value: 'serviceCategoryId'
        // children: 'servicePackages'
      },
      list: [],
      inited: false
    }
  },
  computed: {
    selectedOptions: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  watch: {
    option: {
      handler: function(val) {
        if (val.serviceId && val.classId && val.classId.length === 2) {
          if (this.inited) {
            this.selectedOptions = null
          }
          this.fetchList()
        }
      },
      immediate: true
    }
  },
  mounted() {
    // this.fetchList()
    this.inited = true
  },
  methods: {
    handleChange(val) {
      console.log(arguments)
      const item = this.list.find(i => i.serviceCategoryId === val) || {}
      console.log(item)
      this.callback && this.callback(item)
    },
    fetchList() {
      const [classIdLevel1, classIdLevel2] = this.option.classId
      this.$store.dispatch('account/getservicecategorys', {
        payload: {
          serviceId: this.option.serviceId,
          classIdLevel1,
          classIdLevel2
        },
        success: (res) => {
          this.list = res.data.records.map(i => {
            i.children = (i.servicePackages || []).map(s => ({
              ...s,
              pServiceCategoryId: s.serviceCategoryId,
              serviceCategoryId: s.servicePackageId,
              serviceCategoryName: s.servicePackageName
            }))
            return i
          })
        },
        fail: () => {
          this.list = []
        }
      })
    }
  }
}
</script>
